import { useQuery } from "@tanstack/react-query";

import { getMyInvoice, listMyInvoices } from "@/features/invoices/api/invoicesApi";

export const INVOICES_KEYS = {
  myList: ["invoices", "me"] as const,
  myDetail: (id: string) => ["invoices", "me", id] as const,
};

export function useMyInvoices() {
  return useQuery({
    queryKey: INVOICES_KEYS.myList,
    queryFn: listMyInvoices,
  });
}

export function useMyInvoice(id: string | undefined) {
  return useQuery({
    queryKey: id ? INVOICES_KEYS.myDetail(id) : ["invoices", "me", "noop"],
    queryFn: () => getMyInvoice(id as string),
    enabled: !!id,
  });
}
